import React from "react";
import HeartBar from "./Elements/HeartBar";
import ScrollToTop from "./Elements/ScrollToTop";
import Brands from "./Elements/Brands";

import { Link } from "react-router-dom";

import "./Style/Footer.css";

const Footer = (): JSX.Element => {
  return (
    <div className="footer-wrapper">
      <ScrollToTop />
      <Brands />
      <HeartBar />
      <footer className="footer my-3" role="contentinfo">
        <div className="container">
          <div className="row text-center">
            <div className="col-sm-3 col-6 py-2">
              <Link to="/Faq">F.A.Q.</Link>
            </div>
            <div className="col-sm-3 col-6 py-2">
              <a rel="noopener noreferrer" href="https://www.wbstraining.de/unternehmen/impressum/" target="_blank">
                Impressum
              </a>
            </div>
            <div className="col-sm-3 col-6 py-2">
              <a rel="noopener noreferrer" href="https://www.wbstraining.de/allgemeine-geschaeftsbedingungen/" target="_blank">
                AGB
              </a>
            </div>
            <div className="col-sm-3 col-6 py-2">
              <a rel="noopener noreferrer" href="https://www.wbstraining.de/datenschutz/" target="_blank">
                Datenschutz
              </a>
            </div>
          </div>
        </div>
      </footer>
      <div className="lzk-version-container">
        <small>Version 1.4.2</small>
      </div>
    </div>
  );
};

export default Footer;
